import { render } from "./App.vue?vue&type=template&id=a059eff4&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/bootstrap.min.css?vue&type=style&index=0&id=a059eff4&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=a059eff4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a059eff4"]])

export default __exports__